import { useCallback, useRef } from 'react';

import {
    PlayerAPI,
    TimeMode,
} from 'bitmovin-player/modules/bitmovinplayer-core';
import type { PlayerEventBase } from 'bitmovin-player/types/core/Events';

import isFunction from 'utils/function.ts';

import { PlayerProps } from 'components/Player/types.ts';

export default (
    player: PlayerAPI | null,
    onProgress: PlayerProps['onProgress'],
) => {
    const prevTimeChangeEventTimestamp = useRef(Math.floor(Date.now() / 1000));

    return useCallback(
        (event: PlayerEventBase) => {
            const eventTimestampInSeconds = Math.floor(event.timestamp / 1000);

            if (
                prevTimeChangeEventTimestamp.current <
                    eventTimestampInSeconds &&
                isFunction(onProgress) &&
                player
            ) {
                onProgress({
                    absolutePosition: eventTimestampInSeconds,
                    relativePosition: player.getCurrentTime(
                        TimeMode.RelativeTime,
                    ),
                    timestamp: eventTimestampInSeconds,
                });
            }

            prevTimeChangeEventTimestamp.current = eventTimestampInSeconds;
        },
        [onProgress, player],
    );
};
